import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateCreditPayload, CreateCreditResponse, createCredit } from '~/services/PaymentsService';

const MEMBER_CREDIT_BASE_KEY = 'memberCredits' as const;

/**
 * Keys for a member's credits and balance. Any query that reads them should use `list(memberId)`
 * so it refreshes when a credit is granted through `useCreateCredit`.
 */
export const memberCreditQueryKeys = {
  all: [MEMBER_CREDIT_BASE_KEY] as const,
  lists: () => [...memberCreditQueryKeys.all, 'list'] as const,
  list: (memberId: string) => [...memberCreditQueryKeys.lists(), memberId] as const,
};

export function useCreateCredit() {
  const queryClient = useQueryClient();

  return useMutation<CreateCreditResponse, Error, CreateCreditPayload>({
    mutationFn: (payload) => createCredit(payload),
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: memberCreditQueryKeys.list(payload.fk_member) });
    },
  });
}
